import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["event"];
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Debugger from "./debugger";
import { createElement, prepare, setLoadTime } from "./tools";
import { injectMouseFlowScript } from "services/mouseFlow";
var interval = {
  ref: undefined,
  count: 1
};
var promise = {};
promise.ref = new Promise(function (resolve) {
  promise.resolve = resolve;
});
var defaults = {
  page: {
    businessUnit: "ELS:RP:ST",
    language: "en",
    noTracking: "false",
    productName: "EV",
    environment: "prod",
    productAppVersion: "new"
  },
  visitor: {}
};
function pushPageLoad() {
  var data = _objectSpread(_objectSpread({}, defaults), {}, {
    event: "pageLoad",
    page: _objectSpread(_objectSpread({}, defaults.page), {}, {
      name: "init:load",
      type: "NP-GP"
    })
  });
  Debugger.event(data);
  window.appData.push(data);
}
function init() {
  var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.app;
  if (window.appData) {
    Debugger.log("Initialization has already completed.");
    return;
  }
  _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _window, _prepare, src;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            Debugger.log("Starting...");
            if (app) {
              _context.next = 4;
              break;
            }
            throw Error("The App is not ready yet.");
          case 4:
            _prepare = prepare(app, defaults), src = _prepare.src;
            _context.next = 7;
            return createElement("script", {
              src: src,
              type: "text/javascript",
              async: true
            })["catch"](function () {
              throw new Error("Couldn't load the script '".concat(src, "'."));
            });
          case 7:
            if ((_window = window) !== null && _window !== void 0 && _window.pageDataTracker) {
              _context.next = 9;
              break;
            }
            throw new Error("The PageDataTracker can't be found.");
          case 9:
            Debugger.log("Initialized.");
            window.appData = window.appData || [];
            window.pageDataTracker.debug = false;
            pushPageLoad();
            // for leveraging the pageData variables within mouseflow
            // Adobe objects have to be successfully loaded, both
            // AA and MF have a dependency on windows.app being available
            injectMouseFlowScript(app);
            promise.resolve();
            if (interval.ref) clearInterval(interval.ref);
            _context.next = 22;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);
            Debugger.error("Something wrong happened while initializing.", _context.t0);
            if (!interval.ref) {
              interval.ref = setInterval(function () {
                interval.count += 1;
                if (window.appData || interval.count > 10) {
                  clearInterval(interval.ref);
                  Debugger.warn("The Analytics couldn't be initialized.\n     Please check your network connection then run :\n     Analytics.init();");
                  return;
                }
                Debugger.log("Trying to initial again for ".concat(interval.count, " times..."));
                init();
              }, 5000);
            }
          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 18]]);
  }))();
}
function push(_ref2) {
  var event = _ref2.event,
    options = _objectWithoutProperties(_ref2, _excluded);
  if (!event) {
    Debugger.warn("Sending 'event' is required.");
    return;
  }
  promise.ref.then(function () {
    var _options$page;
    if (!window.appData) {
      Debugger.error("The Analytics is not initialized. Event Name: ".concat(event, ", Options"), options);
      return;
    }
    var data = _objectSpread(_objectSpread(_objectSpread({
      event: event
    }, defaults), options), {}, {
      page: _objectSpread(_objectSpread(_objectSpread({}, defaults.page), (_options$page = options === null || options === void 0 ? void 0 : options.page) !== null && _options$page !== void 0 ? _options$page : {}), setLoadTime())
    });
    Debugger.event(data);
    window.appData.push(data);
  });
}
var Analytics = {
  init: init,
  push: push,
  "debugger": {
    on: Debugger.on,
    off: Debugger.off
  }
};
if (typeof window !== "undefined") window.Analytics = Analytics;
export * from "./Events";
export default Analytics;